import { render, staticRenderFns } from "./PlayerInfoDialog.vue?vue&type=template&id=02f56ed8&scoped=true"
import script from "./PlayerInfoDialog.vue?vue&type=script&lang=js"
export * from "./PlayerInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./PlayerInfoDialog.vue?vue&type=style&index=0&id=02f56ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f56ed8",
  null
  
)

export default component.exports